import { BoxProps, Heading } from "@hightouch/htui";
import { Card } from "src/components/card";
import { PropsWithChildren } from "react";
import { GlowLogo } from "src/components/auth/glow-logo";

type AuthCardProps = {
  gap?: BoxProps["gap"];
  heading?: string;
};

export function AuthCard({
  gap = 10,
  heading,
  children,
}: PropsWithChildren<AuthCardProps>) {
  return (
    <Card
      justifyContent="space-between"
      bg="white"
      boxShadow="lg"
      borderRadius="16px"
      borderColor="transparent"
      gap={gap}
      pos="relative"
      p={12}
      textAlign="center"
      w="500px"
      maxW="100%"
    >
      <GlowLogo
        pos="absolute"
        top="-36px"
        left="50%"
        transform="translateX(-50%)"
      />
      {heading && <Heading size="lg">{heading}</Heading>}
      {children}
    </Card>
  );
}
